export const TOKEN_TIME = 'tokenTime'
export const TOKEN_TIME_VALUE = 6000 * 36 * 60
